<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>Risk Filter Management</v-toolbar-title>
          <v-toolbar-items>
            <v-menu offset-y left :close-on-content-click="false">
              <template v-slot:activator="{ attrs, on }">
                <div v-bind="attrs" v-on="on" class="add_btn">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn text v-bind="attrs" v-on="on">
                        <v-icon v-bind="attrs" v-on="on"
                          >add</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Add Filter</span>
                  </v-tooltip>
                </div>
              </template>
              <v-list class="add-filter-menu-content">
                <v-list-group
                  v-for="(section, i) in rawLeadStructure"
                  :key="`SPECIAL_LEAD_SECTION_${i}`"
                  :prepend-icon="section.icon"
                >
                  <template v-slot:activator>
                    <v-list-item-title>{{ section.text }}</v-list-item-title>
                  </template>
                  <v-list-group
                    v-for="(field, j) in section.children"
                    :key="`SPECIAL_LEAD_FIELD_${j}`"
                    no-action
                    sub-group
                  >
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="field.text"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>

                    <v-list-item
                      v-for="(title, i) in states"
                      :key="i"
                      link
                      @click="addFilter(field, section, title)"
                    >
                      <v-list-item-title
                        v-text="title.text"
                      ></v-list-item-title>
                    </v-list-item>
                  </v-list-group>
                </v-list-group>
              </v-list>
            </v-menu>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <div
            class="card-channel"
            :style="`borderColor: ${$vuetify.theme.themes.light.primary}`"
          >
            <div class="filter-channel">
              <div class="content">
                <v-card-title class="card-title">
                  <v-row>
                    <v-col cols="10">
                      <keep-alive>
                        <v-tabs show-arrows v-model="portfolio">
                          <v-tab
                            v-for="group in filteredGroups"
                            :key="`GROUP_TAB_${group.text}`"
                            @click="onClickGroup(group)"
                          >
                            {{ group.text }}
                          </v-tab>
                        </v-tabs>
                      </keep-alive>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field
                        v-model="searchValue"
                        placeholder="Search"
                        outlined
                        dense
                        prepend-inner-icon="mdi-magnify"
                        type="text"
                        hide-details
                        clearable
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-progress-linear
                  v-if="progress.portfolioFilter"
                  color="primary"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
                <v-tabs-items v-model="portfolio">
                  <v-tab-item
                    v-for="group in filteredGroups"
                    color="#fff"
                    :key="`GROUP_TAB_ITEM_${group.text}`"
                    class="p-v-10"
                  >
                    <v-card-text style="padding: 10px">
                      <vue-perfect-scrollbar
                        style="height: calc(100vh - 400px)"
                      >
                        <div v-if="tool.isNotEmpty(portfolioFilterArr)">
                          <filter-card
                            v-for="(item, index) in portfolioFilterArr"
                            :key="index"
                            :showFilter="item"
                            :operatedBy="operatedBy"
                            :roleId="roleId"
                            :token="activePortfolio.portfolioToken"
                            @getList="getList"
                            @deleteFilterById="deleteFilterById"
                            @updateLeadFilterState="updateLeadFilterState"
                            :ref="`childCardCH${index}`"
                          ></filter-card>
                        </div>
                      </vue-perfect-scrollbar>
                    </v-card-text>
                  </v-tab-item>
                </v-tabs-items>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <add-error-dialog
        :showDialog="showDialog"
        :errorMessage="errorMessage"
      ></add-error-dialog>
      <add-successful-dialog :dialog="showDialog"></add-successful-dialog>
      <v-dialog
        v-model="isUpdating"
        overlay-color="#2296F3"
        overlay-opacity="0.6"
        persistent
        width="300"
      >
        <v-card>
          <v-card-text style="height: 36px !important">
            Please stand by
            <v-progress-linear
              indeterminate
              color="#009688"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { Tool, DataType } from '@/util/index'
import FilterCard from '@/components/panda/filter/FilterCard'
import AddErrorDialog from '@/components/panda/setting/dialog/AddErrorDialog.vue'
import AddSuccessfulDialog from '@/components/panda/setting/dialog/AddSuccessfulDialog.vue'
import { FilterApi } from '@/api/pandaria'
import RawLeadStructure from '@/setting/raw-lead-strucure.js'
import OperatorEnum from '@/setting/operator-enum.js'

const tool = new Tool()
export default {
  name: 'PortfolioFilterManagement',
  components: {
    FilterCard,
    AddErrorDialog,
    AddSuccessfulDialog
  },
  data: () => ({
    portfolio: 0,
    rawLeadStructure: RawLeadStructure,
    states: DataType.statesValue,
    operatorEnum: OperatorEnum,
    searchValue: '',
    progress: {
      portfolioFilter: false
    },
    tool: tool,
    errorMessage: '',
    isUpdating: false,
    showDialog: {
      error: false,
      successful: false
    },
    portfolioFilterArr: [],
    portfolioList: [],
    activePortfolio: {},
    operatedBy: {
      firstName: '',
      lastName: '',
      email: ''
    },
    roleId: '',
    accountPortfolioList: []

  }),
  watch: {
    'store.getters.getAccount': function (val) {
      if (tool.isNotEmpty(val)) {
        this.account = val
        this.operatedBy.firstName = val?.firstName
        this.operatedBy.lastName = val?.lastName
        this.operatedBy.email = val?.email
        this.roleId = val?.roleId
        this.accountPortfolioList = val.portfolioIdList || []
      }
    }
  },
  computed: {
    filteredGroups () {
      return this.searchValue
        ? this.portfolioList.filter((group) =>
          group.text.toLowerCase().includes(this.searchValue.toLowerCase())
        )
        : this.portfolioList
    },
    account: {
      get () {
        return this.store.getters.getAccount
      },
      set () {}
    }
  },
  mounted () {
    this.account = this.store.getters.getAccount
    if (tool.isNotEmpty(this.account)) {
      this.operatedBy.firstName = tool.isNotEmpty(this.account?.firstName) ? this.account.firstName : ''
      this.operatedBy.lastName = tool.isNotEmpty(this.account?.lastName) ? this.account.lastName : ''
      this.operatedBy.email = tool.isNotEmpty(this.account?.email) ? this.account.email : ''
      this.roleId = tool.isNotEmpty(this.account?.roleId) ? this.account.roleId : ''
      this.accountPortfolioList = tool.isNotEmpty(this.account?.portfolioIdList) ? this.account.portfolioIdList : []
    }
    this.getPortfolioList()
  },
  methods: {
    getPortfolioList () {
      const $this = this
      FilterApi.getPortfolioList(
        (res) => {
          if (tool.isNotEmpty(res)) {
            res.map((item) => {
              if ($this.accountPortfolioList.includes(item.portfolioId)) {
                DataType.Portfolio.map((i) => {
                  if (item.portfolioId === i.value) {
                    const portfolio = {
                      text: i.text,
                      ...item
                    }
                    $this.portfolioList.push(portfolio)
                  }
                })
              }
            })
          }
          $this.onClickGroup($this.portfolioList[0])
        },
        (error) => {
          $this.errorMessage = error.message
          $this.showDialog.error = true
        }
      )
    },
    getList () {
      this.onClickGroup()
    },
    onClickGroup (group = this.activePortfolio) {
      this.activePortfolio = group
      const $this = this
      $this.progress.portfolioFilter = true
      $this.portfolioFilterArr = []
      const input = {
        roleId: $this.roleId,
        token: this.activePortfolio.portfolioToken
      }
      FilterApi.getListRisk(
        input,
        (res) => {
          $this.progress.portfolioFilter = false
          if (tool.isNotEmpty(res.filters)) {
            $this.portfolioFilterArr = res.filters
            $this.portfolioFilterArr.map(item => {
              item.token = $this.activePortfolio.portfolioToken
            })
          }
        },
        () => {
          $this.progress.portfolioFilter = false
        }
      )
    },
    async addFilter (field, section, title) {
      const $this = this
      const operator = $this.operatorEnum.filter(item => {
        return item.text === title.text
      })
      const data = {
        sectionKey: section.text,
        fieldKey: field.text,
        operator: operator[0].value
      }
      let count = 0
      $this.portfolioFilterArr.forEach((e) => {
        if (
          e.operator === data.operator &&
          e.fieldKey === data.fieldKey &&
          e.sectionKey === data.sectionKey
        ) {
          $this.errorMessage = 'Filter for ' + data.sectionKey + '.' + data.fieldKey + ' ' + ' is existed'
          $this.showDialog.error = true
          count++
        }
      })
      if (count === 0) {
        const input = {
          roleId: $this.account.roleId,
          filter: data,
          operatedBy: JSON.stringify($this.operatedBy),
          token: $this.activePortfolio.portfolioToken
        }
        FilterApi.saveRiskFilter(
          input,
          (res) => {
            $this.onClickGroup()
          },
          (error) => {
            $this.errorMessage = error.message
            $this.showDialog.error = true
          }
        )
      }
    },
    deleteFilterById (id, token) {
      const $this = this
      const input = {
        id: id,
        operatedBy: $this.operatedBy,
        token: token
      }
      FilterApi.deleteRiskFilterValue(
        input,
        () => {
          $this.onClickGroup()
        },
        (error) => {
          $this.isUpdating = false
          $this.errorMessage = error.message
          $this.showDialog.error = true
        }
      )
    },
    updateLeadFilterState (data, before) {
      const $this = this
      let count = 0
      let index = 0
      if ($this.portfolioFilterArr.length === 1) {
        $this.isUpdating = true
        FilterApi.saveRiskFilter(
          data,
          function () {
            $this.portfolioFilterArr[0].operator = data.filter.current
            $this.isUpdating = false
            $this.showDialog.successful = true
          },
          (error) => {
            $this.isUpdating = false
            $this.errorMessage = error.message
            $this.showDialog.error = true
            $this.onClickGroup()
          }
        )
      } else if ($this.portfolioFilterArr.length > 1) {
        $this.portfolioFilterArr.forEach((e) => {
          if (
            e.fieldKey === data.filter.fieldKey &&
            e.id === data.filter.id &&
            e.operator === data.filter.operator &&
            e.sectionKey === data.filter.sectionKey &&
            e.token === data.token
          ) {
            $this.errorMessage = 'Filter for ' + data.filter.sectionKey + '.' + data.filter.fieldKey + ' ' + $this.states.find((e) => e.value === data.filter.operator).text + ' is existed'
            $this.showDialog.error = true
            count++
          }
        })
        for (let i = 0; i < $this.portfolioFilterArr.length; i++) {
          const e = $this.portfolioFilterArr[i]
          if (
            e.fieldKey === before.fieldKey &&
            e.id === before.id &&
            e.operator === before.operator &&
            e.sectionKey === before.sectionKey &&
            e.token === before.token
          ) {
            index = i
          }
        }
        if (count === 0) {
          $this.isUpdating = true
          FilterApi.saveRiskFilter(
            data,
            function () {
              $this.portfolioFilterArr[index].operator = data.filter.operator
              $this.isUpdating = false
              $this.showDialog.successful = true
            },
            (error) => {
              $this.isUpdating = false
              $this.errorMessage = error.message
              $this.showDialog.error = true
              $this.onClickGroup()
            }
          )
        } else {
          $this.$refs[`childCardCH${index}`][0].select_state =
            $this.states.find((e) => e.value === before.operator).text
        }
      }
    }
  }
}
</script>
<style>
.theme--light.v-list-item:not(.v-list-item--active):not(
    .v-list-item--disabled
  ) {
  color: rgba(0, 0, 0, 0.87);
  background-color: #fff;
}
.v-list-group__header .v-list-item .v-list-item--active .v-list-item--link .theme--light {
  background-color: #fff !important;
}
</style>
<style scoped>
.add_btn {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.v-card__text {
  width: 100%;
}
.tab-content {
  margin: 0;
  padding: 5px;
  width: 100%;
}
.card-channel {
  flex: 0 0 100%;
  max-width: 100%;
  background: #fff;
  border: 3px solid;
  border-radius: 5px;
}
.filter-channel {
  display: inline-block;
  width: 100%;
}
.card-title {
  display: flex;
  justify-content: space-between;
}
.v-card__title {
  padding: 10px 10px 0 !important;
}
.content {
  border: none;
  margin: 0px 10px 10px;
  height: calc(100vh - 295px);
}
.add-filter {
  position: relative;
}
.add-filter-menu-content {
  max-height: 500px;
  width: 300px;
}
</style>
